(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    /* PowerSamoray: during a quick add or a quantity change, the cart scripts update the subtotal at
     once, but the delivery and total rows come back from the server a moment later. Dim them until
     the cart has settled, so an old delivery price is never shown as final. */
  (() => {
    if (window.psDeliveryBusyReady) return;
    window.psDeliveryBusyReady = true;

    const root = document.documentElement;
    let safety = 0;

    const settle = () => {
      clearTimeout(safety);
      delete root.dataset.psDeliveryBusy;
    };

    document.addEventListener('ps:cart-count-adjust', () => {
      root.dataset.psDeliveryBusy = '';
      clearTimeout(safety);
      safety = window.setTimeout(settle, 8000);
    });
    document.addEventListener('ps:cart-sync-idle', settle);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ps-browse-tools"] && !Shopify.designMode) return;
  try {
    class PsBrowseTools extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.frame = requestAnimationFrame(() => {
        this.root = this.closest('results-list');
        if (!this.root) return;
        this.nav = this.querySelector('nav');
        this.links = Array.from(this.querySelectorAll('a')).filter(link => {
          const heading = this.root.querySelector(link.getAttribute('href'));
          if (!heading) { link.remove(); return false; }
          return true;
        });
        this.nav.hidden = !this.links.length;
        this.rails = Array.from(this.root.querySelectorAll('.organized-all-products__group:not(.organized-all-products__group--flat) .organized-all-products__grid')).map(grid => {
          const track = document.createElement('div');
          track.className = 'ps-rail-track';
          track.setAttribute('aria-hidden','true');
          const thumb = document.createElement('span');
          track.append(thumb);
          grid.after(track);
          const rail = {grid,track,thumb};
          grid.addEventListener('scroll', () => this.updateRail(rail), {signal, passive:true});
          return rail;
        });
        this.nav.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link) return;
          const heading = this.root.querySelector(link.getAttribute('href'));
          if (!heading) return;
          event.preventDefault();
          this.jumpController?.abort();
          this.jumpController = new AbortController();
          const jumpSignal = this.jumpController.signal;
          const offset = () => this.headerHeight() + 40;
          const align = () => {
            if (jumpSignal.aborted) return;
            requestAnimationFrame(() => {
              if (jumpSignal.aborted || !heading.isConnected) return;
              const difference = heading.getBoundingClientRect().top - offset();
              if (Math.abs(difference) > 2) window.scrollTo({top: window.scrollY + difference, behavior:'instant'});
              this.jumpController?.abort();
            });
          };
          window.addEventListener('scrollend', align, {once:true,signal:jumpSignal});
          window.addEventListener('touchstart', () => this.jumpController?.abort(), {once:true,passive:true,signal:jumpSignal});
          window.addEventListener('wheel', () => this.jumpController?.abort(), {once:true,passive:true,signal:jumpSignal});
          const top = heading.getBoundingClientRect().top + window.scrollY - offset();
          const behavior = matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth';
          window.scrollTo({top,behavior});
          if (behavior === 'instant') align();
        }, {signal});
        window.addEventListener('scroll', () => this.schedule(), {signal,passive:true});
        window.addEventListener('resize', () => this.schedule(), {signal,passive:true});
        this.resize = new ResizeObserver(() => this.schedule());
        this.rails.forEach(({grid}) => this.resize.observe(grid));
        this.update();
      });
    }
    headerHeight() {
      const header = document.querySelector('#header-component') || document.querySelector('#header-group');
      const rect = header?.getBoundingClientRect();
      return rect ? Math.max(0, Math.min(rect.bottom, window.innerHeight)) : 0;
    }
    schedule() {
      if (this.tick) return;
      this.tick = requestAnimationFrame(() => { this.tick = 0; this.update(); });
    }
    update() {
      const boundary = this.headerHeight() + 100;
      let current = this.links[0];
      this.links.forEach(link => {
        const heading = this.root.querySelector(link.getAttribute('href'));
        if (heading?.getBoundingClientRect().top <= boundary) current = link;
      });
      this.links.forEach(link => link.setAttribute('aria-current',String(link === current)));
      this.rails.forEach(rail => this.updateRail(rail));
    }
    updateRail({grid,track,thumb}) {
      const max = grid.scrollWidth - grid.clientWidth;
      track.hidden = max < 2 || innerWidth > 749;
      if (track.hidden) return;
      const width = track.clientWidth;
      const thumbWidth = Math.min(width,Math.max(20,width * grid.clientWidth / grid.scrollWidth));
      const progress = Math.min(1,Math.max(0,Math.abs(grid.scrollLeft) / max));
      const direction = getComputedStyle(grid).direction === 'rtl' ? -1 : 1;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (progress * (width - thumbWidth) * direction) + 'px)';
    }
    disconnectedCallback() {
      this.jumpController?.abort();
      this.controller?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.tick);
      this.rails?.forEach(({track}) => track.remove());
    }
  }
  if (!customElements.get('ps-browse-tools')) customElements.define('ps-browse-tools',PsBrowseTools);
  } catch(e) { console.error(e); }
})();

})();
